export default __webpack_public_path__ + "static/media/HistoricAudioComment.dbb25360.svg";